import { get, put } from 'lib/API';

export const getSalesOrderForConsignment = async (
  [orderId]: any[],
  { token }: any
): Promise<any> => {
  return await get(`v1/salesOrder/${orderId}`, token);
};

export const retrySalesOrderCreation = async (
  [consignmentId]: any[],
  { token }: any
): Promise<any> => {
  return await put(`v1/salesOrder/${consignmentId}`, token);
};

export const cancelSalesOrder = async (
  [consignmentId, reason, cancelledBy, salesOrderRejectionCode, isAutomaticCancellationMode]: any[],
  { token }: any
): Promise<any> => {
  const payload = { reason, cancelledBy, salesOrderRejectionCode, isAutomaticCancellationMode };

  return await put(`v1/salesOrder/${consignmentId}/cancel`, token, payload);
};

export const retryCancelSalesOrder = async (
  [consignmentId]: any[],
  { token }: any
): Promise<any> => {
  const payload = { isRetry: true };
  
  return await put(`v1/salesOrder/${consignmentId}/cancel`, token, payload);
};